import {Injectable} from '@angular/core';
import {Http} from "@angular/http";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {TopListRow} from "./top-list-row";

@Injectable()
export class TopListService {

  public currentList$: BehaviorSubject<TopListRow[]> = new BehaviorSubject<TopListRow[]>(null);

  constructor(private http: Http) {

  }

  public refresh() {
    this.http.get("api/players/toplist").subscribe(
      res => {
        let data = res.json();
        if (data.rows) {
          let array: TopListRow[] = data.rows.sort(function (a: TopListRow, b: TopListRow) {
            return b.score - a.score;
          });
          //set ordinans
          if (array.length > 0) {
            array[0].ordinal = 1;
            for (let i = 1; i < array.length; ++i) {
              if (array[i].score == array[i - 1].score) {
                array[i].ordinal = array[i - 1].ordinal;
              }
              else {
                array[i].ordinal = (i + 1);
              }
            }
          }

          this.currentList$.next(array);
        }
        else {
          console.log("Warning: responce had no players");
        }
      },
      error => {
        console.error(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/top-list.service.ts